exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\nsvg[data-v-9668a5ac] {\n  pointer-events: none;\n  position: fixed;\n  right: 0;\n}\nsvg polygon[data-v-9668a5ac],\nsvg rect[data-v-9668a5ac] {\n  pointer-events: auto;\n}\n", ""]);

